import { useEffect, useState } from "react";
import {
  ArrowRight,
  ArrowUpRight,
  CheckCircle2,
  Play,
  ShieldCheck,
  Wrench,
} from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import ProductCard from "../components/ProductCard";
import { db } from "../lib/data";
import { siteConfig } from "../data/site";
export function Hero() {
  return (
    <section className="hero">
      <div className="hero-graphic">
        <span>K</span>
        <span>I</span>
        <span>Z</span>
        <span>A</span>
        <span>K</span>
      </div>
      <div className="hero-shade" />
      <div className="hero-copy">
        <span>© 26</span>
        <h1>
          Innovating Comfort,
          <br />
          Delivering Excellence
        </h1>
        <p>Fans and airflow products built for everyday living.</p>
      </div>
      <Link className="hero-link" to="/shop">
        <span>
          Find out more.
          <br />
          See collections.
        </span>
        <ArrowUpRight size={17} />
      </Link>
    </section>
  );
}
export function Excellence() {
  return (
    <Reveal>
      <section className="excellence section-pad">
        <div className="eyebrow">↘</div>
        <div className="split">
          <h2>
            The art of
            <br />
            excellence
          </h2>
          <div className="excellence-side">
            <button className="play-button">
              <Play size={13} />
            </button>
            <p>
              KIZAK focuses on dependable airflow, practical engineering and
              products that fit naturally into everyday spaces.
            </p>
          </div>
        </div>
      </section>
    </Reveal>
  );
}
const cd = {
  ceiling: "Reliable airflow for everyday living.",
  pedestal: "Portable high-volume airflow.",
  cabin: "Compact ventilation.",
  "table-wall": "Versatile everyday airflow.",
  "table-wall-moving": "Oscillating airflow for wider coverage.",
  "fresh-air": "Fresh-air circulation.",
  ventilation: "Enclosed-space ventilation.",
  "extension-cords": "Practical power distribution.",
  "roto-grill": "Focused roto grill airflow.",
};
export function Collections() {
  const [c, setC] = useState([]);
  useEffect(() => {
    db.categories().then(setC);
  }, []);
  return (
    <Reveal>
      <section className="collections">
        <div className="collection-label">collections</div>
        <div className="wide-content">
          <div className="section-head">
            <div>
              <span className="eyebrow">collections</span>
              <h2>Explore our collections</h2>
            </div>
          </div>
          <div className="collection-list">
            {c.map((x) => (
              <Link key={x.id} to={`/collections/${x.slug}`}>
                <span>{x.name}</span>
                <small>{cd[x.id] || x.description}</small>
                <div className="collection-hover-media">
                  <div className="collection-placeholder">{x.name}</div>
                  <em>{cd[x.id] || x.description}</em>
                </div>
                <span className="circle-arrow">
                  <ArrowUpRight size={15} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Reveal>
  );
}
export function Featured() {
  const [p, setP] = useState([]);
  useEffect(() => {
    db.products({ limit: 3 }).then(setP);
  }, []);
  return (
    <Reveal>
      <section className="featured section-pad">
        <div className="featured-copy">
          <div>
            <h2>
              Products that
              <br />
              work quietly.
            </h2>
            <p>Explore live KIZAK catalogue data.</p>
          </div>
          <Link to="/shop">
            Discover the products <ArrowUpRight size={15} />
          </Link>
        </div>
        <div className="featured-grid">
          {p.map((x) => (
            <ProductCard key={x.id} product={x} />
          ))}
        </div>
      </section>
    </Reveal>
  );
}
export function ProductRail() {
  const [p, setP] = useState([]);
  useEffect(() => {
    db.products({ limit: 15 }).then(setP);
  }, []);
  return (
    <Reveal>
      <section className="products-rail">
        <div className="rail-track">
          {p.map((x) => (
            <ProductCard key={x.id} product={x} />
          ))}
        </div>
        <Link className="rail-link" to="/shop">
          All Products <ArrowRight size={15} />
        </Link>
      </section>
    </Reveal>
  );
}
export function VisualBreak() {
  return (
    <div className="visual-break">
      <div>© 26</div>
      <strong>{siteConfig.tagline}</strong>
    </div>
  );
}
export function ServicePromise() {
  return (
    <Reveal>
      <section className="testimonials section-pad">
        <div className="section-head">
          <h2>More than a product.</h2>
          <p>
            The KIZAK platform connects commerce, ownership and home service.
          </p>
        </div>
        <div className="testimonial-track">
          <article>
            <CheckCircle2 size={22} />
            <p>Purchase records remain connected to the customer account.</p>
          </article>
          <article>
            <ShieldCheck size={22} />
            <p>Warranty and service workflows are auditable.</p>
          </article>
          <article>
            <Wrench size={22} />
            <p>
              Technicians manage field visits from a mobile-first workspace.
            </p>
          </article>
        </div>
      </section>
    </Reveal>
  );
}
export function Testimonials() {
  return <ServicePromise />;
}
export function Feed() {
  return null;
}
export function CTA() {
  return (
    <section className="cta">
      <h2>
        We design fans that
        <br />
        breathe with you.
      </h2>
      <Link to="/about">
        <ArrowUpRight size={18} /> Learn more
        <br />
        about KIZAK
      </Link>
    </section>
  );
}
